// extracted by mini-css-extract-plugin
export default {"root":"Search_root__eiX89","input":"Search_input__klILD","cancel":"Search_cancel__fhB11"};